/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { default_theme as theme } from '../../emotion/theme'
import { head, get, map, keys, split, size } from 'lodash'
import { adminNumberRangeList } from '../actions/admin_number_range'
import { CardHeader } from '../../components/layout/CardHeader'
import { LanguageFlag } from '../../components/LanguageFlag'
import { FormikCheckboxField } from '../../components/form/CheckboxField'
import { Separator } from '../../components/layout/Separator'
import { Formik, Form, FieldArray, Field } from 'formik'
import Loading from '../../components/Loading'
import { FormikTextarea } from '../../components/form/TextareaField'
import { FormikInputField } from '../../components/form/InputField'
import AdminMainLayout from './AdminMainLayout'
import BusyMask from '../../components/BusyMask'
import Timestamp from '../../components/Timestamp'
import Card from '../../components/layout/Card'
import { Col, Row, Container, Navbar, Nav } from 'react-bootstrap'
import { Form as BootstrapForm } from 'react-bootstrap'
import * as Yup from 'yup'
import {showSuccess, showError} from '../../actions/Error'
import Button from 'react-bootstrap/Button'
import CardInfoText from '../../components/layout/CardInfoText'
import { BlueButton } from '../../components/layout/BlueButton'
import { FormikGeneralFormErrors } from '../../components/form/GeneralFormErrors'
import { handleSubmitResult } from '../../actions/form'

const validationSchema = Yup.object().shape({
    'name': Yup.string().required("Required"),
    'start_number': Yup.string().required("Required"),
    'end_number': Yup.string().required("Required"),
})

class AdminNumberRange extends Component {

    componentDidMount() {
        const { dispatch, number_range_id } = this.props
        dispatch(adminNumberRangeList.ensureObjectLoaded(number_range_id))
    }

    componentDidUpdate(prev_props) {
        const { dispatch, number_range_id } = this.props
        dispatch(adminNumberRangeList.ensureObjectLoaded(number_range_id))
    }

    onSave = (values, formik_funcs) => {
        const { history, onSubmit, dispatch, number_range_id } = this.props

        const on_ok = function(json) {
            dispatch(adminNumberRangeList.invalidateList())
            showSuccess("Saved", "Number range saved")

            if ( ! number_range_id ) {
                history.push(`/admin/number_range/${json.id}`)
            }
        }
        if ( number_range_id ) {
            values.id = number_range_id
            return dispatch(adminNumberRangeList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminNumberRangeList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }
    
    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    renderForm(formik_props) {

        return (
            <div>
              <Row>
                <Col>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Name</BootstrapForm.Label>
                    <FormikInputField name="name" placeholder="Name" />
                  </BootstrapForm.Group>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Start</BootstrapForm.Label>
                    <FormikInputField name="start_number" placeholder="From" />
                  </BootstrapForm.Group>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>End</BootstrapForm.Label>
                    <FormikInputField name="end_number" placeholder="End" />
                  </BootstrapForm.Group>
                  
                </Col>
              </Row>
              <Row>
                <Col>
                  <BlueButton type="submit">Save</BlueButton>
                </Col>
              </Row>
            </div>
        )
    }

    render() {
        const { initial_values, is_loading, is_busy, number_range, number_range_id } = this.props
        const that = this
        const title = `${get(number_range, ["name"], 'New number range')}`

        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           
                                           {name: 'number_ranges',
                                            label: 'Number Ranges',
                                            url: '/admin/number_ranges'},
                                           
                                           {name: 'number_range',
                                            label: (
                                                <div css={breadcrumb_item}>
                                                  {get(number_range, ["name"], 'New number range')}
                                                </div>
                                            ),
                                            url: `/admin/number_range/${number_range_id}`
                                           }
            ]}>
              <Container fluid>
                { is_busy && <BusyMask /> }
                { is_loading && <Loading /> }

                <CardHeader title={title} />
                <Separator variant="h30" />
                
                { ! is_loading && 
                  <Formik
                      initialValues={initial_values}
                      onSubmit={that.onSave}
                      enableReinitialize={true}
                      validationSchema={validationSchema}
                      >
                    {formik_props => {
                         const { values } = formik_props
                         return (
                             <Form>
                               <FormikGeneralFormErrors render={(msg) => <Row><Col>{msg}</Col></Row>} />
                               <Row>
                                 <Col>
                                   <Card>
                                     { that.renderForm(formik_props) }
                                   </Card>
                                 </Col>
                               </Row>
                             </Form>
                         )}
                    }
                  </Formik>
                }
              </Container>
            </AdminMainLayout>
        )
    }
    
}

function mapStateToProps(state, props) {
    const number_range_id = get(props, ["match", "params", "number_range_id"], null)
    const number_range = adminNumberRangeList.getObject(number_range_id)
    return {
        number_range_id,
        number_range,
        is_loading: adminNumberRangeList.isLoading(),
        is_busy: adminNumberRangeList.getIsSavingObject(),
        initial_values: number_range
    }
}

export default connect(mapStateToProps)(AdminNumberRange)

const breadcrumb_item = css`
display: flex;
align-items: center;
`
